import { render, staticRenderFns } from "./BoardMenu.vue?vue&type=template&id=d767f41c&scoped=true&"
import script from "./BoardMenu.vue?vue&type=script&lang=js&"
export * from "./BoardMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d767f41c",
  null
  
)

export default component.exports